export default __webpack_public_path__ + "static/media/backpack_dark.2a979fdf.png";